<template>
  <article class="info-section elr-container-full">
    <div class="elr-row">
      <div class="elr-col-full">
        <div class="info-section-header">
          <InfoSectionHeading>{{item.name}}</InfoSectionHeading>
        </div>
        <figure v-if="item.image" class="item-image">
          <img :src="`/pony-images/${item.image}`" :alt="item.name">
        </figure>
        <div class="pony-info-section">
          <InfoSectionHeading>Pony Details</InfoSectionHeading>
          <div class="pony-details">
            <ul class="details-list">
              <li v-if="item.grouping" class="item-detail">
                <p>
                  <span class="elr-bold">Grouping:</span>
                  <router-link :to="`/grouping/${item.grouping.id}`">{{capitalize(item.grouping.name)}}</router-link>
                </p>
              </li>
              <li v-if="item.generation" class="item-detail">
                <p>
                  <span class="elr-bold">Generation:</span>
                  <router-link :to="`/generation/${item.generation.id}`">{{capitalize(item.generation.name)}}</router-link>
                </p>
              </li>
            </ul>
            <ul class="details-list">
              <li v-if="item.price" class="item-detail">
                <p>
                  <span class="elr-bold">Price:</span>
                  {{currency(item.price)}}
                </p>
              </li>
              <li v-if="item.status" class="item-detail">
                <p>
                  <span class="elr-bold">Status:</span>
                  {{capitalize(item.status)}}
                </p>
              </li>
              <li v-if="item.condition" class="item-detail">
                <p>
                  <span class="elr-bold">Condition:</span>
                  {{capitalize(item.condition)}}
                </p>
              </li>
              <li v-if="item.purchase_date" class="item-detail">
                <p>
                  <span class="elr-bold">Purchased:</span>
                  {{humanDate(item.purchase_date)}}
                </p>
              </li>
              <li v-if="item.notes" class="item-detail">
                <p>
                  <span class="elr-bold">Notes:</span>
                  {{item.notes}}
                </p>
              </li>
            </ul>
          </div>
          <div class="button-holder">
            <button
              class="elr-button elr-button-primary"
              @click="confirmReceipt"
              v-if="item.status === 'pending'"
            >Confirm Item</button>
            <button
              class="elr-button elr-button-primary"
              @click="sellItem"
              v-if="item.status === 'not selling'"
            >Sell Item</button>
            <button
              class="elr-button elr-button-primary"
              @click="completeSale"
              v-if="item.status === 'listed'"
            >Complete Sale</button>
          </div>
        </div>
        <pre>{{item}}</pre>
      </div>
    </div>
  </article>
</template>

<script>
import { mapState } from 'vuex';
import { capitalize, currency, humanDate } from '../../utils/helpers';
import InfoSectionHeading from '../../components/InfoSectionHeading/InfoSectionHeading';
// import ItemNavigation from '../../components/ItemNavigation/ItemNavigation';

export default {
  name: 'HerdItem',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  created() {
    this.fetchItem(this.id);
  },
  components: {
    InfoSectionHeading,
    // ItemNavigation
  },
  computed: {
    ...mapState({
      user: state => state.currentUser.currentUser,
      status: state => state.herd.status,
    }),
    item() {
      const item = this.$store.getters['herdItem/getItemById'](this.id)

      if (item) {
        return item;
      }

      return {};
    },
  },
  methods: {
    capitalize,
    currency,
    humanDate,
    fetchItem(id) {
        this.$store.dispatch('herdItem/FETCH', {
          id
        });
    },
    sellItem() {
      // console.log(id);
    }
  }
};
</script>
